import { CompareActionTypes, ProductGroupFredhopperTypes, WishListActionTypes } from '../../../enums/ActionEnums';
import { toggleComparedStateForItems } from '../../../redux/compare/reducers/CompareReducer';
import { updateWishListProducts } from '../../../redux/wishList/reducers/WishListReducer';
import { updateProductGroupProducts } from '../../../util/ProductGroupUtil';
import { setDeliveryPromiseToProducts } from '../../../util/ProductUtil';
export const loadProductGroupFredhopperReducer = (initialData = null) => {
    var _a;
    const initialProductGroupFredhopperState = (initialData === null || initialData === void 0 ? void 0 : initialData.productGroupFredhopperId)
        ? { [initialData.productGroupFredhopperId]: (_a = initialData.products) !== null && _a !== void 0 ? _a : [] }
        : {};
    return (state = initialProductGroupFredhopperState, action) => {
        var _a;
        switch (action.type) {
            case WishListActionTypes.ADD_PRODUCT:
                return updateProductGroupProducts(state, updateWishListProducts, action, true);
            case WishListActionTypes.REMOVE_PRODUCT:
                return updateProductGroupProducts(state, updateWishListProducts, action, false);
            case CompareActionTypes.COMPARE_UPDATE_PRODUCTS:
                return updateProductGroupProducts(state, toggleComparedStateForItems, action.payload);
            case ProductGroupFredhopperTypes.SET_DELIVERY_PROMISE: {
                const { productGroupId } = action.payload;
                if (!productGroupId)
                    return state;
                return Object.assign(Object.assign({}, state), { [productGroupId]: setDeliveryPromiseToProducts((_a = state[productGroupId]) !== null && _a !== void 0 ? _a : [], action.payload) });
            }
            case ProductGroupFredhopperTypes.SET_FREDHOPPER_DATA:
                return Object.assign(Object.assign({}, state), action.payload);
            default:
                return state;
        }
    };
};
export const productGroupFredhopperReducer = loadProductGroupFredhopperReducer();
